import React, { Fragment } from 'react';
import { Tooltip } from 'react-tooltip';

// One shared tooltip serving every supporting-member star on the page. The stars
// themselves are server-rendered ERB (.member-star-anchor); react-tooltip's
// anchorSelect binds this single instance to all of them, so we don't mount a
// React island per card.
//
// Opens on hover/focus (after a short delay) AND on click/tap — openEvents lists
// both so desktop hover and mobile tap both work. clickable keeps the in-tooltip
// links interactive; delayHide gives a grace period to move the pointer from the
// star into the tooltip without it closing.
const MemberStarTooltip = () => (
  <Tooltip
    anchorSelect=".member-star-anchor"
    place="bottom"
    clickable
    openEvents={{ mouseenter: true, focus: true, click: true }}
    closeEvents={{ mouseleave: true, blur: true }}
    globalCloseEvents={{ clickOutside: true, escape: true }}
    delayShow={250}
    delayHide={150}
    border="1px solid #4f4f4f"
    className="memberStarTooltip"
  >
    <Fragment>
      <p className="mb-2 leading-tight">
        This poster is a{' '}
        <a
          className="cursor-pointer text-teal-light hover:text-teal"
          href="/membership"
          target="_blank"
        >
          supporting member.
        </a>
      </p>
      <p>
        <a
          className="cursor-pointer text-teal-light hover:text-teal no-underline"
          href="/membership"
          target="_blank"
        >
          Learn more here{' '}
          <span
            className="icon-arrow-right font-normal"
            style={{ fontSize: '12px' }}
          ></span>
        </a>
      </p>
    </Fragment>
  </Tooltip>
);

export default MemberStarTooltip;
